import { tenantEnv } from 'tenant/host_config';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const defaults = {
  BASE_ROUTE: '/',
  PRICE_LIST_URL:
    'https://docs.google.com/spreadsheets/d/1YdRIARouay4IvNDhUqADxd2jMcKxTYMh9WcfqH9vrbA/edit#gid=0',
  ZENDESK_URL: 'https://ontruck.zendesk.com',
  WS_DEBUG: false,
  QUOTE_DEBOUNCE_DELAY: 1500,
  WS_DEBOUNCE_DELAY: 500,
  MAX_FILE_SIZE: 15 * 1024 * 1024,
  PAGE_SIZE_FOR_ALL: 100,
};
const extractDomainRootRE = /[a-z0-9-]+\.(ontruck.(com|io))/;
const domainParts = extractDomainRootRE.exec(window.location.hostname);
const DOMAIN_ROOT = (domainParts && domainParts[1]) || 'ontruck.com';
const populate = (str = '') => str.replace('%DOMAIN_ROOT%', DOMAIN_ROOT);
const BASE_URL = populate(tenantEnv.BASE_URL);
const API_URL = `${BASE_URL}/v1/`;
const API_URL_V2 = `${BASE_URL}/v2/`;

const AUTH_URL = `${BASE_URL}/v1/auth/`;
const SAML_AUTH_URL = `${BASE_URL}/v1/saml/`;

const SAML_CONFIG = {
  LOGIN: {
    url: `${SAML_AUTH_URL}login/`,
    params: {},
    token_key: 'refresh',
  },
  LOGOUT: {
    url: `${SAML_AUTH_URL}logout/`,
    params: {},
    token_key: 'refresh',
  },
  REFRESH_TOKEN: {
    url: `${SAML_AUTH_URL}jwt/refresh/`,
    params: {},
    token_key: 'refresh',
  },
};

const AUTH_CONFIG = {
  LOGIN: {
    url: `${AUTH_URL}convert-token/`,
    params: {
      grant_type: 'convert_token',
      client_id: tenantEnv.AUTH_CLIENTID,
      backend: 'google-oauth2',
    },
    token_key: 'token',
  },
  LOGOUT: {
    url: `${AUTH_URL}revoke-token/`,
    params: {
      client_id: tenantEnv.AUTH_CLIENTID,
    },
    token_key: 'token',
  },
  REFRESH_TOKEN: {
    url: `${AUTH_URL}token/`,
    params: {
      grant_type: 'refresh_token',
      client_id: tenantEnv.AUTH_CLIENTID,
    },
    token_key: 'refresh_token',
  },
};

const getAuthConfig = (useSAML = false) => {
  return useSAML ? SAML_CONFIG : AUTH_CONFIG;
};
const AUTH_TYPES = getTenantPreLoginConfig().login_auth_types;

const configs = {
  ...defaults,
  BASE_URL,
  API_URL,
  API_URL_V2,
  AUTH_URL,
  AUTH_CONFIG,
  SAML_CONFIG,
  getAuthConfig,
  AUTH_TYPES,
  GEO_URL: populate(process.env.REACT_APP_GEO_URL),
  ODOO_URL: populate(process.env.REACT_APP_ODOO_URL),
  WS_URL: populate(process.env.REACT_APP_WS_URL),
  WS_DEBUG: false,
  GOOGLE_APPS_CLIENTID: process.env.REACT_APP_GOOGLE_APPS_CLIENTID,
  ONTRUCK_AUTH_CLIENTID: tenantEnv.AUTH_CLIENTID,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SEGMENT_KEY: process.env.REACT_APP_SEGMENT_KEY,
  SENTRY_RELEASE: process.env.REACT_APP_SENTRY_RELEASE,
  ENVIRONMENT: tenantEnv.ENVIRONMENT,
  AIRTABLE_CONTRACTS_URL: process.env.REACT_APP_AIRTABLE_CONTRACTS_URL,
  APP_VERSION: `v${process.env.REACT_APP_VERSION}`,
  POI_SERVICE_URL: process.env.REACT_APP_POI_SERVICE_URL,
  STREAMSETS_SERVICE_URL: process.env.REACT_APP_STREAMSETS_SERVICE_URL,
};

export default configs;
